import React from 'react';

import './ErrorPage.scss';

const ErrorPage: React.FC = () => <div className="error-page">Error</div>;

export default ErrorPage;
